import React from 'react';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import { useSelector } from "react-redux";
import {pathOr} from "ramda";

const DateTime = ({ field, onChange, errors = {}, value, small = false,module }) => {
	const { userPreference, config } = useSelector((state) => state.config);
	// const timezone = pathOr('', ['attributes', 'global','timezone'], userPreference);
	const timef = pathOr(config.default_time_format, ['attributes', 'global','timef'], userPreference);
	const datef = pathOr(config.default_date_format, ['attributes', 'global','datef'], userPreference);
	
	const date_reg_format = pathOr(config.default_date_format, ['attributes', 'global','date_reg_format'], userPreference);
	const time_reg_format = pathOr(config.default_date_format, ['attributes', 'global','time_reg_format'], userPreference);
	const date_reg_positions = pathOr(config.default_date_format, ['attributes', 'global','date_reg_positions'], userPreference);

	// console.log("timezone",timezone);
	// console.log("timef",timef);
	// console.log("datef",datef);
	// console.log("value",value);

	// let sepStr = '';
	// let sepArr = ['-','/','.'];
	// sepArr.map((sep)=>{
	// 	sepStr = datef.indexOf(sep)===1?sep:"";
	// });

	let newDatef= datef.replace("Y","yyyy");
	newDatef= newDatef.replace("m","MM");
	newDatef= newDatef.replace("d","dd");

	let newTimef= timef.replace("H","HH");
	newTimef= newTimef.replace("h","hh");
	newTimef= newTimef.replace("i","mm");
	newTimef= newTimef.replace("a","aaa");
	newTimef= newTimef.replace("A","a");
	
	///newTimef= newTimef.replace("d","dd");
	// console.log("newTimefqqq",newTimef);
	// console.log("newDatef",newDatef);

	let iserror = errors[field.name] ? true : false;
	let isRequired = field.required === 'true' ? '*' : '';
	const handleChange = (date,newDatef) => {
		//console.log("handleChange date",date);
		//console.log("handleChange newDatef",newDatef);
		if(date && date !=='Invalid Date')
		{
			onChange(newDatef);
			delete errors[field.name];
		}else{
			onChange("");
			errors[field.name]= "Invalid Date";
		} 
		// let current_datetime = new Date(date);
		
		// onChange(current_datetime.getFullYear() + "-" + ("0" + (current_datetime.getMonth() + 1)).slice(-2) + "-" + ("0" + current_datetime.getDate()).slice(-2) + " " + ("0" + current_datetime.getHours()).slice(-2) + ":" + ("0" + current_datetime.getMinutes()).slice(-2) + ":" + ("0" + current_datetime.getSeconds()).slice(-2))

	};
	const isTime = (timeStr) =>{
		var timeRegex = time_reg_format;
		timeRegex = timeRegex.replace(/[ ]*\([^)]*m\)/i, '');
		if (timeStr.length === 0) {
			return true;
		}
		let myregexp = new RegExp(timeRegex);
		if (!myregexp.test(timeStr)) {
			return false;
		}
		return true;
	}

	const getDateObject=(dtStr) =>{
		if (dtStr.length === 0) {
			return true;
		}
		let myregexp = new RegExp(date_reg_format);
		if (myregexp.exec(dtStr)){
			var dt = myregexp.exec(dtStr);
		}
		else{
		return false;
		}
		var yr = dt[date_reg_positions['Y']];
		var mh = dt[date_reg_positions['m']];
		var dy = dt[date_reg_positions['d']];
		var dtar = dtStr.split(' ');
		var date1='';
		if (typeof (dtar[1]) != 'undefined' && isTime(dtar[1],time_reg_format)) {
			var t1 = dtar[1].replace(/am/i, ' AM');
			t1 = t1.replace(/pm/i, ' PM');
			t1 = t1.replace(/\./, ':');
			date1 = new Date(mh + '/' + dy + '/' + yr + ' ' + t1);
		} else {
			date1 = new Date(mh + '/' + dy + '/' + yr);
		}
		if (isNaN(date1.valueOf())) {
			return null;
		}
		return date1;
	}

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			{/* <KeyboardDateTimePicker
				// autoOk
				animateYearScrolling={true}
				minutesStep={module==='Meetings' && (field.name==='date_start' || field.name==='date_end')?15:1}
				error={iserror}
				variant="inline"
				inputVariant="outlined"
				label={field.label + " " + isRequired}
				id={field.name}
				name={field.name}
				format={`${newDatef} ${newTimef}`}
				value={value ? getDateObject(value) : null}
				size={small ? 'small' : 'medium'}
				fullWidth
				InputAdornmentProps={{ position: 'start' }}
				onChange={(date,newDatef) => handleChange(date,newDatef)} //onChange(formatDate(date))
				helperText={errors[field.name] ? errors[field.name] : null}
			// InputProps={{ readOnly: true }}
			/> */}
			<KeyboardDateTimePicker
			margin="normal"
			// id="date-picker-dialog"
			// label="Date picker dialog"
			// format={`${newDatef} ${newTimef}`}
			// value={value ? getDateObject(value) : null}
			// onChange={(date,newDatef) => handleChange(date,newDatef)} //onChange(formatDate(date))
			KeyboardButtonProps={{
			  'aria-label': 'change date',
			}}
			
				animateYearScrolling={true}
				minutesStep={module==='Meetings' && (field.name==='date_start' || field.name==='date_end')?15:1}
				error={iserror}
				variant="dialog"
				inputVariant="outlined"
				label={field.label + " " + isRequired}
				id={field.name}
				name={field.name}
				format={`${newDatef} ${newTimef}`}
				value={value ? getDateObject(value) : null}
				size={small ? 'small' : 'medium'}
				fullWidth
				InputAdornmentProps={{ position: 'start' }}
				onChange={(date,newDatef) => handleChange(date,newDatef)} //onChange(formatDate(date))
				helperText={errors[field.name] ? errors[field.name] : null}
		  />
		</MuiPickersUtilsProvider>
	);
};

export default DateTime;
